import { fetchCountries, fetchRegions } from '../api/address';

export const ADDRESS_REGIONS_LOAD_START = 'address-regions-load-start';
export const ADDRESS_REGIONS_LOAD_COMPLETE = 'address-regions-load-complete';
export const ADDRESS_COUNTRIES_LOAD_START = 'address-countries-load-start';
export const ADDRESS_COUNTRIES_LOAD_COMPLETE =
    'address-countries-load-complete';

export const addressRegionsLoadStart = () => ({
    type: ADDRESS_REGIONS_LOAD_START,
});

export const addressRegionsLoadSuccess = (response) => ({
    type: ADDRESS_REGIONS_LOAD_COMPLETE,

    payload: {
        response,
    },
});

export const addressRegionsLoadFailure = (error, detail) => ({
    type: ADDRESS_REGIONS_LOAD_COMPLETE,

    payload: {
        error,
        detail,
    },

    error: true,
});

export const addressCountriesLoadStart = () => ({
    type: ADDRESS_COUNTRIES_LOAD_START,
});

export const addressCountriesLoadSuccess = (response) => ({
    type: ADDRESS_COUNTRIES_LOAD_COMPLETE,

    payload: {
        response,
    },
});

export const addressCountriesLoadFailure = (error, detail) => ({
    type: ADDRESS_COUNTRIES_LOAD_COMPLETE,

    payload: {
        error,
        detail,
    },

    error: true,
});

/**
 * Wraps the `fetchCountries` method with action dispatching for loading, success,
 * and error states.
 *
 * @param dispatch
 * @returns {Promise.<*>}
 */
export const dispatchLoadCountries = () => (dispatch, getState) => {
    const {
        address: { countries: { isLoading, content: hasCountries } = {} } = {},
    } = getState();

    if (hasCountries || isLoading) {
        return;
    }

    dispatch(addressCountriesLoadStart());
    return fetchCountries()
        .then((countries) => dispatch(addressCountriesLoadSuccess(countries)))
        .catch((error) => dispatch(addressCountriesLoadFailure(error)));
};

/**
 * Wraps the `fetchRegions` endpoint with action dispatching for loading, success,
 * and error states.
 *
 * @param dispatch
 * @returns {Promise.<*>}
 */
export const dispatchLoadRegions = () => (dispatch, getState) => {
    const {
        address: {
            regionsByCountry: { isLoading, content: hasRegions } = {},
        } = {},
    } = getState();

    if (hasRegions || isLoading) {
        return;
    }

    dispatch(addressRegionsLoadStart());
    return fetchRegions()
        .then((regions) => dispatch(addressRegionsLoadSuccess(regions)))
        .catch((error) => dispatch(addressRegionsLoadFailure(error)));
};
